<template>
    <div v-show="( itemType == 'booking') || showExpiryDate">

        <div class="row labelContainer">
            <div class="col-md-3 col-xs-4">
                <label class="">Set expiry date</label>
            </div>

            <div class="col-md-9 col-xs-8">
                <div class="material-switch ">
                    <input id="expiry_date_is_active" autocomplete="off"
                           name="expiry_date_is_active"
                           v-model="hasExpiryDate" type="checkbox"  @change="changeIsExpiryDate">
                    <label class="label-default" for="expiry_date_is_active"></label>

                </div>
            </div>
        </div>
        <div class="row labelContainer" v-show="hasExpiryDate == 1">
            <div class="col-md-3 col-xs-4" >
                <label class=""> Expiry Date </label>
            </div>
            <div class="col-md-9 col-xs-8" >
                <div id="expiryDatePicker" class="input-group date">
                        <span class="input-group-addon">
                            <i class="fa fa-calendar"></i>
                        </span>
                    <input ref="expiryDate" id="expiryDate" v-model="expiryDate" autocomplete="off"  class="date text_input form-control"
                           name="expiryDate" type="text">
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import {changeExpiryDate,updateExpiryDate} from "@/modules/Forms/api"

export default {
    name: "ExpiryDate",
    props: {
        isExpiryDate : 0,
        expiryDateInfo : '',
        itemId : 0,
        itemType : '',
        viewPage : false,
        dateFormat: {
            required: true,
            type: String
        },
        bookingStatus:0
    },
    data() {
        return {
            hasExpiryDate : this.isExpiryDate,
            expiryDate:this.expiryDateInfo
        }
    },
    components: {

    },
    computed: {
        showExpiryDate(){
            if (this.bookingStatus == 3 ){
                return true;
            }
            else {
                return false;
            }
        }
    },
    methods: {
        initializeExpiryDatePickerComponent() {
            const vm = this;
            $(this.$refs['expiryDate']).datepicker({
                todayBtn: "linked",
                todayHighlight: true,
                keyboardNavigation: false,
                forceParse: false,
                calendarWeeks: true,
                autoclose: true,
                format: vm.dateFormat
                // Your datepicker options here
            }).on('changeDate', function(e) {
                vm.expiryDate = e.target.value;
                if (e.target.id === "expiryDate"){
                    vm.updateExpiryDate(e.target.value);
                }
            });
            // Add any additional logic if needed
        },
        updateExpiryDate(value){
            // updateExpiryDate
            if(this.viewPage) {
                updateExpiryDate(this.itemId, value).then(response => {
                    if (response.status) {
                        $.notify('Expiry date has been updated successfully', 'success')
                    }
                })
            }

        },
        changeIsExpiryDate(){
            let vm =this;

            if(vm.viewPage){
                let flag = !vm.hasExpiryDate
                changeExpiryDate(vm.itemId , flag).then(response => {
                    if (response.status){
                        $.notify('Expiry date has been changed successfully', 'success')
                    }
                })
            }


        },
    },
    mounted() {
        this.$nextTick(() => {
            let vm = this;
            setTimeout(function (e){
                if(vm.hasExpiryDate == "0"){
                    $("#expiry_date_is_active").prop("checked", false)
                }
                vm.initializeExpiryDatePickerComponent();
            },2000)

        })
    },
    created() {

    }

}
</script>

<style scoped>
.selected {
    font-weight: bold;
}
#followUpDatePicker{
    //width: 35%;
}
#expiryDatePicker span{
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px !important;
}

#expiryDate{
    border-top-right-radius: 15px !important;
    border-bottom-right-radius: 15px !important;
}

.material-switch{
    width: 50px;
    float: left;
}
.immediately_class{
    float: left;
}

@media (max-width: 767px) {
    #followUpDatePicker{
        width: 100%;
    }
}

</style>